import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth/useAuth';

/**
 * Sends anybody without a session to sign in, remembering where they were going.
 * Without the `from` state a shared deep link silently becomes the home page after
 * sign-in, which reads as the link being wrong.
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const { me, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }
  if (!me) {
    return <Navigate to="/signin" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
